import { createContext, useContext } from 'react';

import { isEmpty } from 'lodash';

import { IBudget } from 'modules/checkout/domain/entities';

export type TBudgetSource = 'LINK' | 'CART';
export type TPreCheckoutStep =
  | 'FINISH_REGISTRATION'
  | 'FACIAL_RECOGNITION'
  | 'BUDGET_SUMMARY'
  | 'LINK_CHECKOUT'
  | 'MULTIPLE_METHODS';

export interface IPreCheckoutContext {
  budgetId: number | undefined;
  /**
   * De onde o orçamento veio. O carrinho e o link compartilham a mesma tela de checkout, mas
   * diferem no que acontece ao concluir — só o carrinho precisa ser esvaziado, por exemplo.
   */
  source: TBudgetSource | undefined;
  activeSteps: TPreCheckoutStep[];
  start(data: { budget: IBudget; source: TBudgetSource }): void;
  nextStep(): void;
  hasStep(step: TPreCheckoutStep): boolean;
}

export const PreCheckoutContext: React.Context<IPreCheckoutContext> =
  createContext({} as IPreCheckoutContext);

export const usePreCheckout = () => {
  const context = useContext(PreCheckoutContext);

  if (isEmpty(context)) {
    throw new Error(
      'usePreCheckout should be called within a PreCheckoutContext',
    );
  }

  return context;
};
